@import "../../scss/mixins";

// a side that slides in from the left of the screen
:host {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 33%;
  min-width: 400px;
  max-width: 700px;
  z-index: 100;
  background-color: #0c1027;
  transition: transform 0.5s ease-in-out;

  section {
    height: 100%;
    display: grid;
    grid-template-rows: 1fr minmax(min-content, 75px) 1fr 60px;
    grid-template-columns: 1fr;

    // no grid-gap for the last row
    & > *:last-child {
      row-gap: 0;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  button {
    @include sitenna-button;
    height: 35px;
    padding: 0 10px;
    min-width: none;
  }

  .map-section {
    padding: 0 10px;
  }

  .text-section {
    color: #fff;
    font-family: "Rubik", "Barlow", sans-serif;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-inline: 20px;

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .text-group {
        display: flex;
        flex-direction: column;
        text-align: center;

        .value {
          font-weight: 400;
          font-size: 14px;
        }

        .key {
          font-weight: 400;
          font-size: 12px;
          color: var(--color-dark-500);
          margin-bottom: 10px;
        }
      }
    }
  }

  .button-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 10px;
    column-gap: 10px;

    .cancel-button {
      height: 35px;
      width: min-content;
      padding: 0 10px;
      background-color: rgb(69, 80, 135) !important;
    }
  }
}
